module.exports = __webpack_public_path__ + "img/Excel-2-icon.4d733ac1.png";